module.exports = __webpack_public_path__ + "static/media/QTUM.b6154a02.svg";